import { getIn } from 'seamless-immutable';
import { ApolloLink } from '@apollo/client';
import { cookies } from '@catalogo/core-cookies';

const setCookie = (name, value, config) => {
  try {
    const now = new Date();
    const year = now.getFullYear();

    now.setFullYear(year + 1);

    const opts = {
      domain: config.cookieDomain,
      path: '/',
      expires: now.toUTCString(),
    };

    cookies.set(name, value, opts);
  } catch (e) {
    return;
  }
};

export default config =>
  new ApolloLink((operation, forward) =>
    forward(operation).map(data => {
      const region = getIn(data, ['data', 'region']);

      const regionalization = {
        oneDayDelivery: getIn(region, ['oneDayDelivery']),
        b2wRegion: getIn(region, ['b2wRegion']),
        mesoRegion: getIn(region, ['mesoRegion']),
        legionRegion: getIn(region, ['legionRegion']),
        macroRegion: getIn(region, ['macroRegion']),
      };

      Object.keys(regionalization).map(index => {
        if (regionalization[index] !== undefined) {
          setCookie(`${index}`, regionalization[index], config);
        }
      });

      return data;
    })
  );
